import React from 'react';
import Form from 'react-bootstrap/Form';
import { SiteAssignment } from '../Common/SiteAssignment/SiteAssignment';
import { BusinessSiteDto } from '../Requests/useGetUsers';

export interface UserSiteAccess {
  allSites: boolean;
  siteIds: string[];
}

interface UserSitePaneProps {
  sites: BusinessSiteDto[];
  isAdministrator: boolean;
  access: UserSiteAccess;
  onChange: (access: UserSiteAccess) => void;
  showError: boolean;
}

export const UserSitePane = (props: UserSitePaneProps) => {
  if (props.isAdministrator) {
    return <p className="small text-muted mb-0">
      Administrators always have access to all sites, including new ones.
    </p>;
  }

  if (props.sites.length === 0) {
    return <p className="small text-muted mb-0">
      This business has no sites, so this user will have access to every site added later.
    </p>;
  }

  const assignments = props.sites.map(site => ({
    siteId: site.id,
    siteName: site.name,
    assigned: props.access.siteIds.includes(site.id),
  }));

  const showError = props.showError && !props.access.allSites && props.access.siteIds.length === 0;

  return <fieldset className="border-0 p-0 m-0">
    <legend className="visually-hidden">Site access</legend>
    {showError &&
      <p className="small text-danger mb-2" role="alert">Choose at least one site.</p>}
    <Form.Check
      type="radio"
      name="siteAccess"
      id="siteAccessAll"
      label="All Sites"
      checked={props.access.allSites}
      onChange={() => props.onChange({ ...props.access, allSites: true })} />
    <p className="small text-muted ms-4 mb-2">Includes future sites.</p>
    <Form.Check
      type="radio"
      name="siteAccess"
      id="siteAccessSpecific"
      label="Specific Sites"
      checked={!props.access.allSites}
      onChange={() => props.onChange({ ...props.access, allSites: false })} />
    {!props.access.allSites &&
      <div className="ms-4 mt-2">
        <SiteAssignment
          hideSelectAll
          assignedSiteIds={props.access.siteIds}
          sites={assignments}
          assignedSitesChanged={siteIds => props.onChange({ allSites: false, siteIds })} />
      </div>}
  </fieldset>;
};
